'use client';
import { useTranslations } from 'next-intl';
import React from 'react';
import NotFound from '../NotFound';
import { Button } from '../ui/button';
import { Link, useRouter } from '@/i18n/routing';

const NotFoundPage = () => {
  const t = useTranslations('error');
  const router = useRouter();
  return (
    <section className="container mx-auto h-full py-20 text-center">
      <NotFound title={t('NotFoundPage')} />
      <div className="mx-auto my-10 flex w-1/2 flex-wrap gap-4 lg:flex-nowrap">
        <Button rounded={'full'} variant={'Error'} onClick={() => router.refresh()}>
          {t('try-again')}
        </Button>
        <Link href={'/'} className="w-full">
          <Button rounded={'full'}>{t('go-home')}</Button>
        </Link>
      </div>
    </section>
  );
};

export default NotFoundPage;
